import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ShelterNetworkSettingsComponent } from './shelter-network-settings.component';
import { NvDesignLibraryModule } from '../../../nvps-libraries/design/nv-design-library.module';
import { ShelterNetworkSettingsLeftNavComponent } from './shelter-network-settings-left-nav/shelter-network-settings-left-nav.component';
import { ShelterNetworkSettingsRightNavComponent } from './shelter-network-settings-right-nav/shelter-network-settings-right-nav.component';
import { MatMenuModule } from '@angular/material/menu';
import { InfiniteTableModule } from 'Src/ng2/shared/components/list/infinite-table/infinite-table.module';
import { PageHeaderModule } from 'Src/ng2/shared/components/header/page-header/page-header.module';
import { ShelterNetworkSettingsContentComponent } from './shelter-network-settings-content/shelter-network-settings-content.component';
import { ShelterNetworkSettingsMoreButtonComponent } from './shelter-network-settings-more-button/shelter-network-settings-more-button.component';
import { ShelterNetworkDataService } from './shelter-network.data.service';

@NgModule({
  declarations: [
    ShelterNetworkSettingsComponent,
    ShelterNetworkSettingsLeftNavComponent,
    ShelterNetworkSettingsRightNavComponent,
    ShelterNetworkSettingsContentComponent,
    ShelterNetworkSettingsMoreButtonComponent,
  ],
  imports: [CommonModule, InfiniteTableModule, PageHeaderModule, NvDesignLibraryModule, MatMenuModule],
  entryComponents: [ShelterNetworkSettingsMoreButtonComponent],
  providers: [ShelterNetworkDataService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ShelterNetworkSettingsModule {}
